import { render, staticRenderFns } from "./extras-more-info.vue?vue&type=template&id=cb80bea2&scoped=true"
import script from "./extras-more-info.vue?vue&type=script&setup=true&lang=ts"
export * from "./extras-more-info.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./extras-more-info.vue?vue&type=style&index=0&id=cb80bea2&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb80bea2",
  null
  
)

export default component.exports